import React, {ReactNode, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useRootStore} from "@stores/AppStateContext";

import {ItemLine} from '../ItemLine';

import {selectItemPlain} from "../../../actions/ui/selectItem";
import {SearchHeader} from "./SearchHeader";
import {escapeRegExp} from "../../../utils/escapeRegExp";

import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";

import './search-results.css';

export const SearchResults = observer(() => {
    const rootStore = useRootStore();
    const activeWorkspace = rootStore.view.workspace!;
    const isMobile = screenSizeProvider.view !== 'desktop';

    let firstFoundId: string | null = null;

    const titleResults: ReactNode[] = [];
    const contentResults: ReactNode[] = [];

    const foundInContentSearch = new Set();
    const searchRegExp = new RegExp(escapeRegExp(rootStore.search.textInput), 'i');
    for (const searchResult of rootStore.search.textSearchResults) {
        const item =  activeWorkspace.items.get(searchResult.itemId);
        if (!item) {
            continue;
        }
        const searchMatch = item.name.match(searchRegExp);
        if (firstFoundId === null) {
            firstFoundId = searchResult.itemId;
        }
        foundInContentSearch.add(searchResult.itemId);
        contentResults.push(
            <ItemLine
                key={searchResult.itemId}
                item={item}
                level={0}
                searchResult={searchResult}
                highlight={searchMatch ? searchMatch[0]: undefined}
            />
        )
    }

    for (const searchInTitleResult of rootStore.searchTitleMatches) {
        if (foundInContentSearch.has(searchInTitleResult.item.id)) {
            continue;
        }
        if (firstFoundId === null) {
            firstFoundId = searchInTitleResult.item.id;
        }
        titleResults.push(
            <ItemLine
                key={searchInTitleResult.item.id}
                item={searchInTitleResult.item}
                level={0}
                highlight={searchInTitleResult.highlight}
            />
        )
    }

    useEffect(() => {
        if (!isMobile) {
            selectItemPlain(rootStore, rootStore.view.workspace!, firstFoundId);
        }
    },[firstFoundId, isMobile]);

    return (
        <div>
            <SearchHeader
                haveResults={contentResults.length + titleResults.length > 0}
            />
            {contentResults}
            {titleResults}
        </div>
    )
});
